import { createSlice } from "@reduxjs/toolkit";
import { getAllCategories } from "../requests";

const categories = createSlice({
  name: "qrSettings",
  initialState: {
    categoryChange: "",
    categories: [],
    categoriesName: "",
    status: "initial request",
  },
  reducers: {
    categoryChange(state, { payload }) {
      state.categoryChange = payload;
    },
    categoryNameAction(state, { payload }) {
      state.categoriesName = payload;
    },
    setCategory(state, { payload }) {
      if (payload.length) {
        state.categoryChange = [payload[0].advertisingIabCategory.id];
        state.categoriesName = payload[0].advertisingIabCategory.name;
      }
    },
  },
  extraReducers: {
    [getAllCategories.pending]: (state, action) => {
      state.status = "load";
    },
    [getAllCategories.fulfilled]: (state, { payload }) => {
      state.categories = payload;
      state.status = "success";
    },
    [getAllCategories.rejected]: (state, action) => {
      state.status = "failed";
    },
  },
});
export const { categoryChange, categoryNameAction, setCategory } =
  categories.actions;
export default categories.reducer;
